import * as z from 'zod';
import { OfferCustomerResponseDto } from '../types/response';

/** "Lena Berg", or `null` when the admin left both names empty. */
export const formatCustomerPerson = ({ firstName, lastName }: Pick<OfferCustomerResponseDto, 'firstName' | 'lastName'>): string | null =>
  [firstName, lastName].filter(Boolean).join(' ') || null;

// Same limits as the backend live checks – anything else is not checked (and would not save either).
const MAIL_MAX_LENGTH = 254;
const NAME_MAX_LENGTH = 200;

/** The mail as the backend compares it, or `''` while it is no valid mail yet. */
export const toCheckableMail = (value: string): string => {
  const mail = value.trim().toLowerCase();
  return mail.length <= MAIL_MAX_LENGTH && z.string().email().safeParse(mail).success ? mail : '';
};

/** The company name as the backend compares it, or `''` while it is empty. */
export const toCheckableCompanyName = (value: string): string => {
  const name = value.trim();
  return name.length <= NAME_MAX_LENGTH ? name : '';
};
